module.exports = __WEBPACK_EXTERNAL_MODULE_148__;


//////////////////
// WEBPACK FOOTER
// external "jszip"
// module id = 148
// module chunks = 0